import { useState } from 'react';
import { cn } from '@/shared/lib/cn';
import { passbookLogoUrl } from '@/shared/lib/passbook-logo';

interface PassbookLogoThumbProps {
  passbookId?: string;
  name: string;
  backgroundColor?: string;
  className?: string;
}

/** Logo do passbook na listagem — apenas imagem (sem iniciais), igual ao grid. */
export function PassbookLogoThumb({ passbookId, name, backgroundColor, className }: PassbookLogoThumbProps) {
  const [imgError, setImgError] = useState(false);
  const showLogo = Boolean(passbookId) && !imgError;

  return (
    <div
      className={cn(
        'flex size-11 shrink-0 items-center justify-center overflow-hidden rounded-xl border border-border/50 shadow-sm',
        className,
      )}
      style={{ backgroundColor: backgroundColor ?? 'hsl(var(--muted))' }}
      aria-label={name}
    >
      {showLogo ? (
        <img
          src={passbookLogoUrl(passbookId!)}
          alt=""
          className="max-h-[88%] max-w-[88%] object-contain"
          loading="lazy"
          onError={() => setImgError(true)}
        />
      ) : null}
    </div>
  );
}
